//@flow
export const CONFIRMATION_MESSAGE = `
  All traces of this user's account will be gone and their 
  access will be revoked. You'll need to create a new account 
  for them if they need to be reinstated.`



// WEBPACK FOOTER //
// ./src/Users/constants.js